import { render, staticRenderFns } from "./AdminEventLIstReg.vue?vue&type=template&id=405a057f"
import script from "./AdminEventLIstReg.vue?vue&type=script&lang=js"
export * from "./AdminEventLIstReg.vue?vue&type=script&lang=js"
import style0 from "./AdminEventLIstReg.vue?vue&type=style&index=0&id=405a057f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports